module.exports = __webpack_public_path__ + "img/oak_chevron_913m_list.59446917.jpg";